import _ from "lodash";
import moment from "moment";

/**
 * This function takes a string argument and returns an integer.
 * If the given integer is null or empty or an invalid integer the provided default value is returned.
 * The default value if omitted or invalid is defaulted to 0.
 *
 * @param {string} mayBeNumber
 * @param {Number} defaultVal
 *
 * @returns {Number}
 */
export function getIntDefaultIfInValid(
  mayBeNumber: string,
  defaultVal: number = 0
): number {
  return mayBeNumber ? parseInt(mayBeNumber, 10) || 0 : defaultVal || 0;
}

export function generateUUID(): string {
  var d = new Date().getTime();
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function popupCenter(url: string, title: string, w: number, h: number) {

  const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop

  const newWindow = window.open(
    url,
    title,
    "scrollbars=no,status=no,location=no,toolbar=no,menubar=no,width=" +
      w +
      ", height=" +
      h + 
      ", top=" +
      top +
      ", left=" +
      left
  );
  if (newWindow) {
    newWindow.focus();
  }
}

export function formatForRedis(text) {
  return text.replace(/-|_|\+|\./g, function (x) {
    return `\\${x}`;
  });
}

export function attributeKeyGenerator(attributeKey: string) {
  const temp = attributeKey.replace(/([A-Z])/g, " $1").toLowerCase();
  return temp.charAt(0).toUpperCase() + temp.slice(1);
}

export function formatObject(
  originalName: any,
  name: any,
  obj: any,
  cadSections: any,
  cadExtendedSections: any
) {
  if (Array.isArray(obj)) {
    const formatted: any = obj.map((value, index) => {
      if (typeof value === "string") {
        return value;
      } else {
        let tags = {};
        Object.keys(value).map((key) => {
          if (key !== "tag") {
            let keyName;
            if (value.tag) {
              keyName = `${value.tag[0].toLowerCase() + value.tag.slice(1)}${
                key[0].toUpperCase() + key.slice(1)
              }`;
            } else {
              keyName = `${key[0].toLowerCase() + key.slice(1)}${index}`;
            }
            _.merge(
              tags,
              formatObject(
                key,
                keyName,
                value[key],
                cadSections,
                cadExtendedSections
              )
            );
          }
        });
        return tags;
      }
    });
    if (typeof formatted?.[0] === "string") {
      return {
        [name]: formatted.join(", "),
      };
    } else {
      return _.assign.apply(_, formatted);
    }
  } else {
    let field = obj;
    Object.keys(cadExtendedSections).map((section) => {
      cadExtendedSections[section].map((row) => {
        row?.Cols?.map((col) => {
          if (col?.name === originalName) {
            field = col;
          }
        });
      });
    });
    cadSections?.map((section) => {
      section.Rows.map((row) => {
        row?.Cols?.map((col) => {
          if (col?.name === originalName) {
            field = col;
          }
        });
      });
    });

    console.log('field type', field?.type);

    if (obj && obj !== "") {
      switch (field?.type) {
        case "event":
          return {
            [name]: {
              type: "event",
              ...obj,
            },
          };
        case "customer-search":
          return {
            [name]: obj,
          };  
        case "dispatchType":
          return {
            [name]: {
              type: "dispatchType",
              ...obj,
              date: obj.date
                ? moment(obj.date)?.format("MM/DD/YYYY")
                : undefined,
              dateTimestamp: obj.date
                ? moment(obj.date)?.toDate().getTime()
                : undefined,
              time: obj.time ? moment(obj.time)?.format("HH:mm") : undefined,
              timeTimestamp: obj.time
                ? moment(obj.time)?.toDate().getTime()
                : undefined,
            },
          };
        case "rideType":
          return {
            [name]: {
              type: "rideType",
              ...obj,
              date: obj.date
                ? moment(obj.date)?.format("MM/DD/YYYY")
                : undefined,
              dateTimestamp: obj.date
                ? moment(obj.date)?.toDate().getTime()
                : undefined,
              time: obj.time ? moment(obj.time)?.format("HH:mm") : undefined,
              timeTimestamp: obj.time
                ? moment(obj.time)?.toDate().getTime()
                : undefined,
            },
          };
        case "fareType":
          return {
            [name]: {
              type: "fareType",
              ...obj,
            },
          };
        case "notifyType":
          return {
            [name]: {
              type: "notifyType",
              ...obj,
            },
          };
        case "payType":
          return {
            [name]: {
              type: "payType",
              ...obj,
            },
          };
        case "fixed-asset":
          return {
            [name]: {
              type: "incident-location",
              attributes: {
                title: obj?.asset?.name,
              },
              coordinates: {
                lat: obj?.asset?.location?.coordinates?.[1],
                long: obj?.asset?.location?.coordinates?.[0],
              },
            },
          };
        case "responder":
          return {
            [name]: {
              type: "responder",
              ...obj,
            },
          };
        case "vehicleType":
          return {
            [name]: {
              type: "vehicleType",
              ...obj,
            },
          };
        case "vehicle":
          return {
            [name]: {
              type: "vehicle",
              ...obj,
            },
          };
        case "location":
        case "gps":
          return {
            [name]: {
              attributes: {
                address: obj.label,
              },
              coordinates: obj.value.coordinates,
              type: "location",
            },
          };
        case "incident-location":
          return {
            [name]: {
              attributes: {
                address: obj.label,
              },
              coordinates: obj.value.coordinates,
              type: "incident-location",
            },
          };
        case "media":
        case "capture":
        case "file":
        case "signature":
          return {
            [name]: {
              ...obj,
              type: "media",
            },
          };
        case "project":
          return {
            [name]: {
              id: obj?.toString(),
              type: "project",
            },
          };
        case "date":
          return {
            [name]: moment(obj)?.format("MM/DD/YYYY"),
          };
        case "time":
          return {
            [name]: moment(obj)?.format("HH:mm"),
          };
        case "task-picker":
          return {
            [name]: {
              ...obj,
              type: "task",
            },
          };
      }
    }
    return {
      [name]: obj?.toString(),
    };
  }
}
